"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiChevronDown = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const MultiChevronDown = ({ primaryColour = "#E6E6E6", secondaryColour = "#A1A1A1", size = 16, title = "Collapse all", }) => (react_1.default.createElement(Base_1.Base, { smooth: true, size: size, title: title },
    react_1.default.createElement("path", { fill: primaryColour, d: "M8,6l3-4l2,0l-5,7l-5,-7l2,0z" }),
    react_1.default.createElement("path", { fill: secondaryColour, d: "M8,12l3-4l2,0l-5,7l-5,-7l2,0z" })));
exports.MultiChevronDown = MultiChevronDown;
//# sourceMappingURL=MultiChevronDown.js.map